import {useMemo} from 'react';
import {evaluateVisibilityMap} from 'src/app/forms/engine/visibilityEvaluator';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';

export const useFormVisibility = (
  formMeta: IFormFieldV2[],
  formData: IFormDataV2
) => useMemo(() => evaluateVisibilityMap(formMeta, formData), [formMeta, formData]);
